/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnSecurity.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnSecurity-view">
        <Helmet>
          <title>Security - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnSecurity-first">
          <div className="EnSecurity-content">
            <div className="EnSecurity-cardContainer">
              <div className="EnSecurity-cardIcn" />
              <div className="EnSecurity-heading">Payment Processing</div>
            </div>

            <div className="EnSecurity-stripeContainer">
              <div className="EnSecurity-stripeLogo" />
              <div className="EnSecurity-txt">
                CheckPlus works with Stripe to handle all our Visa, MasterCard,
                American Express, Apple Pay, Google Pay transactions.
                <Link to="/EnStripe">
                  <div className="EnSecurity-learnmoreContainer">
                    <div className="EnSecurity-learnmore">Learn More</div>
                    <div className="EnSecurity-arrow" />
                  </div>
                </Link>
              </div>
            </div>

            <div className="EnSecurity-hsbcContainer">
              <div className="EnSecurity-hsbcLogo" />
              <div className="EnSecurity-txt">
                CheckPlus partners with HSBC, so that donors can now make a
                payment or donation on CheckPlus and pay via PayMe.
              </div>
            </div>
          </div>
        </div>

        <div className="EnSecurity-second">
          <div className="EnSecurity-content">
            <div className="EnSecurity-serverContainer">
              <div className="EnSecurity-serverIcn" />
              <div className="EnSecurity-heading">Data and Server</div>
            </div>

            <div className="EnSecurity-stripeContainer">
              <div className="EnSecurity-awsLogo" />
              <div className="EnSecurity-txt">
                CheckPlus works with Amazon Web Services (AWS) and run our
                service in secure ‍ISO27001 compliant data centers.
              </div>
              <div className="EnSecurity-tickContainer">
                <div className="EnSecurity-tickIcn" />
                <div className="EnSecurity-tickTxt">HTTPS</div>
              </div>
              <div className="EnSecurity-tickContainer">
                <div className="EnSecurity-tickIcn" />
                <div className="EnSecurity-tickTxt">SSL</div>
              </div>
              <div className="EnSecurity-tickContainer">
                <div className="EnSecurity-tickIcn" />
                <div className="EnSecurity-tickTxt">ISO27001 Certified</div>
              </div>
            </div>
          </div>
        </div>

        <div className="EnSecurity-footer">
          <div className="EnSecurity-footerNav">
            <Link to="/EnTeam">
              <div className="EnSecurity-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnSecurity-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnSecurity-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnSecurity-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnSecurity-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnSecurity;
